module.exports = __webpack_public_path__ + "img/DOOR-SYSTEM.67d8fda3.jpg";